import React from 'react'
import PropTypes from 'prop-types'

import Notification from 'component/utils/Notification'
import ExclusionModal from '../ExclusionModal/ExclusionModal'
import _ from 'lodash'

class Tables extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    userMatriz: PropTypes.bool.isRequired,
    handleDelete: PropTypes.func,
    toggleEdit: PropTypes.func,
    toggleView: PropTypes.func,
    toggleProcessing: PropTypes.func,
    toggleUpload: PropTypes.func,
    ircList: PropTypes.array,
  }

  renderRow = (irc, key) => {
    const {
      translate,
      handleDelete,
      toggleEdit,
      toggleView,
      toggleProcessing,
      toggleUpload,
      userMatriz,
    } = this.props

    const hasRotativeInventory = irc.lsRotativeInventoryModel.length > 0
    const isNotSynced = irc.isNotSynced === 1 || irc.isNotSynced === true

    return (
      <tr key={key}>
        <td>{irc.dsListName}</td>
        <td className='text-center'>
          {irc.hasErrorProcess && irc.hasErrorProcess > 0 ? (
            <span className='color-danger'>
              {translate('irc.status.error')}
            </span>
          ) : hasRotativeInventory ? (
            <a
              className='text-link'
              role='button'
              onClick={() => toggleProcessing(true, irc)}
            >
              {translate('irc.status.sync')}
            </a>
          ) : isNotSynced ? (
            <span className='color-danger'>
              {translate('irc.status.not.synced')}
            </span>
          ) : (
            <span className='color-gray'>
              {translate('irc.status.processing')}
            </span>
          )}
        </td>
        <td className='text-center'>
          <a
            className='padding'
            role='button'
            onClick={() => toggleView(true, irc)}
          >
            <i className='glyph glyph-eye icon-size' />
          </a>
        </td>
        <td className='text-center'>
          {(!userMatriz && !!irc.inProductsList) || irc.inSentToApi ? (
            <a className='padding disabled-link' role='button'>
              <i className='glyph glyph-pencil icon-size' />
            </a>
          ) : (
            <a
              className='padding'
              role='button'
              onClick={() =>
                !irc.inProductsList
                  ? toggleEdit(true, irc)
                  : toggleUpload(true, irc, true)
              }
            >
              <i className='glyph glyph-pencil icon-size' />
            </a>
          )}
        </td>
        <td className='text-center'>
          {userMatriz && (hasRotativeInventory || isNotSynced) ? (
            <ExclusionModal
              t={translate}
              title={translate('irc.remove.title')}
              message={<p>{translate('irc.remove.message')}</p>}
              confirmButtonMsg='button.yes.remove.subtype'
              onConfirm={() => handleDelete(irc)}
              renderButton={({ onClick }) => (
                <a className='padding' role='button' onClick={onClick}>
                  <i className='color-danger glyph glyph-trash-can icon-size' />
                </a>
              )}
            />
          ) : (
            <a className='padding disabled-link' role='button'>
              <i className='glyph glyph-trash-can icon-size' />
            </a>
          )}
        </td>
      </tr>
    )
  }

  render() {
    const { translate, ircList } = this.props

    const activeList = ircList.filter((irc) => irc.inActive)
    const inactiveList = ircList.filter((irc) => !irc.inActive)

    return (
      <>
        {_.isEmpty(ircList) ? (
          <Notification
            className='notification-warning'
            message={translate('irc.not-found')}
          />
        ) : (
          <>
            {!_.isEmpty(activeList) && (
              <table cellPadding={0} cellSpacing={0} className='new-table'>
                <thead>
                  <tr>
                    <th>{translate('irc.active-lists')}</th>
                    <th width='210' className='text-center'>
                      {translate('irc.status')}
                    </th>
                    <th width='150' className='text-center'>
                      {translate('irc.view-list')}
                    </th>
                    <th width='150' className='text-center'>
                      {translate('irc.edit-list')}
                    </th>
                    <th width='150' className='text-center'>
                      {translate('irc.remove-list')}
                    </th>
                  </tr>
                </thead>
                <tbody>{activeList.map(this.renderRow)}</tbody>
              </table>
            )}

            {!_.isEmpty(inactiveList) && (
              <table
                cellPadding={0}
                cellSpacing={0}
                className={`new-table ${
                  !_.isEmpty(activeList) ? 'margin-top-double' : ''
                }`}
              >
                <thead>
                  <tr>
                    <th>{translate('irc.inactive-lists')}</th>
                    <th width='210' className='text-center'>
                      {translate('irc.status')}
                    </th>
                    <th width='150' className='text-center'>
                      {translate('irc.view-list')}
                    </th>
                    <th width='150' className='text-center'>
                      {translate('irc.edit-list')}
                    </th>
                    <th width='150' className='text-center'>
                      {translate('irc.remove-list')}
                    </th>
                  </tr>
                </thead>
                <tbody>{inactiveList.map(this.renderRow)}</tbody>
              </table>
            )}
          </>
        )}
      </>
    )
  }
}

export default Tables
export { Tables }
